<template>
  <div class="Course flex box_1200">
    <PersonMenu @getData="getData" ref="childRef" />
    <PortraitOne
      type="course"
      :pageTotal="pageTotal"
      :listData="listData"
      @getPageSize="getPageSize"
      @getPageIndex="getPageIndex"
      @change="handleChangeSearch"
    />
  </div>
</template>
<script>
import { studyModuleList } from "@/api/ApiConfig.js";

import PersonMenu from "@/views/Course/components/menu";
import PortraitOne from "@/components/PortraitOne";
export default {
  components: {
    PersonMenu,
    PortraitOne
  },
  data() {
    return {
      queryParams: {
        channel: "课程",
        pageIndex: 1,
        pageSize: 10,
        type: "",
        listType: "",
        type2: "",
        time: ""
      },
      pageTotal: 0,
      listData: []
    };
  },

  created() {
    let query = this.$route.query;
    if (query && query.inputValue) {
      this.queryParams.title = query.inputValue;
      this.queryParams.type = query.inputValue;
      let all = {
        label: "全部课程",
        value: 3,
        CheckIcon: require("@/assets/images/icon/all-blue.png"),
        unCheckIcon: require("@/assets/images/icon/all-gray.png")
      };
      this.$nextTick(() => {
        // 在此处执行你要执行的函数
        this.$refs.childRef.handleClick(all);
      });
    }
    this.getStudyModuleList();
  },
  activated() {
    let query = this.$route.query;
    if (query && query.inputValue) {
      this.queryParams.title = query.inputValue;
      this.queryParams.type = query.inputValue;
      let all = {
        label: "全部课程",
        value: 3,
        CheckIcon: require("@/assets/images/icon/all-blue.png"),
        unCheckIcon: require("@/assets/images/icon/all-gray.png")
      };
      this.$nextTick(() => {
        // 在此处执行你要执行的函数
        this.$refs.childRef.handleClick(all);
      });
    }
    this.getStudyModuleList();
  },
  methods: {
    handleChangeSearch(selc, selb) {
      this.queryParams.type2 = selc
      this.queryParams.time = selb
      this.getStudyModuleList();
    },
    getPageIndex(val) {
      this.queryParams.pageIndex = val;
      this.getStudyModuleList();
    },
    getPageSize(val) {
      this.queryParams.pageSize = val;
      this.getStudyModuleList();
    },
    getData(data) {
      this.queryParams.type = data;
      if (data === "全部实验") {
        this.queryParams.type = "";
      }
      this.getStudyModuleList();
    },
    getStudyModuleList() {
      let queryParams = JSON.parse(JSON.stringify(this.queryParams))
      queryParams.type = queryParams.type === "全部课程" ? "" : queryParams.type;
      queryParams.type2 = queryParams.type2 === "全部" ? "" : queryParams.type2;
      queryParams.time = queryParams.time === "全部" ? "" : queryParams.time
      if(queryParams.type === "热门课程" || queryParams.type === "最新课程") {
        queryParams.listType = queryParams.type
        queryParams.type = ''
      } else {
        queryParams.listType = ''
      }
      studyModuleList(queryParams).then(res => {
        if (res.code === 200) {
          let listData = res.data.list;
          listData.map(item => {
            this.$set(
              item,
              "filterContent",
              item.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, "")
            );
          });
          this.listData = listData;
          this.pageTotal = res.data.total;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.Course {
  padding-top: 109px;
}
</style>
